import { Injectable } from '@angular/core';
import { RutterConnectRequest } from '@api-ui-app/src/app/e-commerce-stores/lib/rutter-connect-request';
import { RutterConnectResponse } from '@api-ui-app/src/app/e-commerce-stores/lib/rutter-connect-response';
import { ECommerceStoreConnectionErrorMessageService } from '@api-ui-app/src/app/e-commerce-stores/services/e-commerce-store-connection-error-message.service';
import { ApiRequestService } from '@gelato-api-ui/core/api/services/api-request.service';
import { loadScript } from '@gelato-api-ui/core/dom/helpers/loadScript';
import { logStoreConnectionFailureEvent } from '@gelato-api-ui/core/e-commerce/helpers/logStoreConnectionFailureEvent';
import { logStoreConnectionSuccessEvent } from '@gelato-api-ui/core/e-commerce/helpers/logStoreConnectionSuccessEvent';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

declare global {
  interface Window {
    Rutter: any;
  }
}

export enum RutterPlatform {
  SHOPIFY = 'SHOPIFY',
  MAGENTO = 'MAGENTO',
  BIG_COMMERCE = 'BIG_COMMERCE',
  WOO_COMMERCE = 'WOO_COMMERCE',
  SQUARESPACE = 'SQUARESPACE',
  WIX = 'WIX',
  SQUARE = 'SQUARE',
  AMAZON = 'AMAZON',
  EBAY = 'EBAY',
  ETSY = 'ETSY',
  PRESTASHOP = 'PRESTASHOP',
}

@Injectable({
  providedIn: 'root',
})
export class RutterIntegrationApiService {
  private baseUrl = 'https://unpkg.com/@rutter/rutter-link@latest';

  constructor(
    private readonly apiRequest: ApiRequestService,
    private readonly eCommerceStoreConnectionErrorMessageService: ECommerceStoreConnectionErrorMessageService,
  ) {}

  loadRutterScript(): Promise<unknown> {
    return loadScript(`${this.baseUrl}`);
  }

  connect(request: RutterConnectRequest): Observable<RutterConnectResponse> {
    return this.apiRequest
      .post<RutterConnectResponse>('/api/ecommerce/v1/platforms/connect', {
        body: request,
      })
      .pipe(
        map((data: any) => data.data),
        tap((response: RutterConnectResponse) => {
          if (response && response.store) {
            logStoreConnectionSuccessEvent(response.store);
          }
        }),
        catchError(error => {
          logStoreConnectionFailureEvent(error);
          this.eCommerceStoreConnectionErrorMessageService.show(error);

          return of(null);
        }),
      );
  }

  activate(storeId: string) {
    return this.apiRequest.get(`/api/ecommerce/v1/platforms/${storeId}:activate`).pipe(
      catchError(error => {
        this.eCommerceStoreConnectionErrorMessageService.show(error);

        return of(null);
      }),
    );
  }
}
